<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'お客様のお声'"
      :sub_title="'〜 Customer Voice〜'"
      :color="'#192C58'"
      :align="'center'"
    ></main-title>
    <customer-voice-list></customer-voice-list>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import CustomerVoiceList from "@/components/organsms/customer_voice/CustomerVoiceList.vue";

export default Vue.extend({
  name: "CustomerVoiceView",

  components: {
    MainTitle,
    CustomerVoiceList
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  main {
    background-color: #e0f5e7;
  }
}

@media only screen and (min-width: 1024px) {
  main {
    background-color: #e0f5e7;
    .main_title {
      text-align: center;
    }
  }
}
</style>
